import { type TableColumnsType } from 'antd'

import { type SortOrderType } from '@/libs/api/types'

/**
 * ソートツールチップの表示遅延（秒）。
 * ヘッダ上を通り過ぎるだけで即座に出ると、真上にあるバーのボタンを覆って
 * 押しにくくなるため、意図して留まったときだけ出る長さにしている
 */
const SORTER_TOOLTIP_MOUSE_ENTER_DELAY = 1

/**
 * カラム定義とソート可能カラムのリストを受け取り、ソート設定を付与したカラム定義を返す
 * @param columns ベースとなるカラム定義
 * @param sortableKeys ソート可能なカラムのキーのリスト
 * @param sorter 現在のソート状態
 * @returns ソート設定が付与されたカラム定義
 */
export const createSortableColumns = <T>(
  columns: TableColumnsType<T>,
  sortableKeys: string[],
  sorter?: { sort?: string; order?: SortOrderType }
): TableColumnsType<T> => {
  return columns.map((col) => {
    // keyが存在し、かつsortableKeysに含まれる場合にsorter: trueを設定
    if (col.key && sortableKeys.includes(col.key as string)) {
      const isSorted = sorter?.sort === col.key
      const sortOrder = isSorted
        ? sorter?.order === 'ASC'
          ? 'ascend'
          : 'descend'
        : null

      return {
        ...col,
        sorter: true,
        sortOrder,
        showSorterTooltip: {
          target: 'full-header',
          mouseEnterDelay: SORTER_TOOLTIP_MOUSE_ENTER_DELAY
        }
      }
    }
    return col
  })
}
